module.exports = __webpack_public_path__ + "assets/img/9cf7092c2b3fc778b4fee34eb5f62655.png";